var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 26C52 40.3594 40.3594 52 26 52C11.6406 52 0 40.3594 0 26C0 11.6406 11.6406 0 26 0C40.3594 0 52 11.6406 52 26Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2 27.8571C28.175 27.8571 27.6821 28.4286 26 28.4286C24.3179 28.4286 23.8286 27.8571 22.8 27.8571C20.15 27.8571 18 30.0071 18 32.6571V33.5714C18 34.5179 18.7679 35.2857 19.7143 35.2857H32.2857C33.2321 35.2857 34 34.5179 34 33.5714V32.6571C34 30.0071 31.85 27.8571 29.2 27.8571ZM32.2857 33.5714H19.7143V32.6571C19.7143 30.9571 21.1 29.5714 22.8 29.5714C23.3214 29.5714 24.1679 30.1429 26 30.1429C27.8464 30.1429 28.675 29.5714 29.2 29.5714C30.9 29.5714 32.2857 30.9571 32.2857 32.6571V33.5714ZM26 27.2857C28.8393 27.2857 31.1429 24.9821 31.1429 22.1429C31.1429 19.3036 28.8393 17 26 17C23.1607 17 20.8571 19.3036 20.8571 22.1429C20.8571 24.9821 23.1607 27.2857 26 27.2857ZM26 18.7143C27.8893 18.7143 29.4286 20.2536 29.4286 22.1429C29.4286 24.0321 27.8893 25.5714 26 25.5714C24.1107 25.5714 22.5714 24.0321 22.5714 22.1429C22.5714 20.2536 24.1107 18.7143 26 18.7143Z",
    fill: "#BFBFBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.ed423fdfbc281db7a5ecaf9a571be02d.svg";
export { ForwardRef as ReactComponent };